import React from "react";

export default {
  id: "giftCardPurchased",
  type: "form",
  form: {
    subject: "Gift_Card_Issue_with_Gift_Card/Vouchers",
    fields: ["FULL_NAME", "POSTCODE", "EMAIL", "PHONE_NUMBER", "VOUCHER_NUMBER", "IMAGE_UPLOAD", "DESCRIPTION"],
    imageMessage: "We accept jpg, jpeg, png or gif",
    message: (
      <p>
        You can{" "}
        <a href="https://www.johnlewis.com/customer-services/prices-and-payment/gift-cards">
          check your gift card balance
        </a>{" "}
        online. We’re afraid we can’t replace lost or stolen gift cards.
      </p>
    ),
  },
};
